import Cookies from 'js-cookie';
import { resolveIsoCode } from '@/composables/geo';

type CountryObject = {
  site: string;
  name: string;
  code: string;
};

const siteUrl = {
  au: 'https://hismileteeth.com',
  us: 'https://us.hismileteeth.com',
  uk: 'https://uk.hismileteeth.com',
  eu: 'https://eu.hismileteeth.com',
  int: 'https://int.hismileteeth.com',
  ca: 'https://ca.hismileteeth.com',
  middleEastDistributor: 'https://hismile.online',
};

const stores = [
  {
    store: siteUrl.au,
    countries: {
      AU: 'Australia',
      NZ: 'New Zealand',
    },
  },
  {
    store: siteUrl['us'],
    countries: {
      US: 'United States',
      UM: 'United States Outlying Islands',
    },
  },
  {
    store: siteUrl['uk'],
    countries: {
      GB: 'United Kingdom',
    },
  },
  {
    store: siteUrl['ca'],
    countries: {
      CA: 'Canada',
    },
  },
  {
    store: siteUrl['eu'],
    countries: {
      AL: 'Albania',
      AD: 'Andorra',
      AT: 'Austria',
      BY: 'Belarus',
      BE: 'Belgium',
      BA: 'Bosnia And Herzegovina',
      BG: 'Bulgaria',
      HR: 'Croatia',
      CY: 'Cyprus',
      CZ: 'Czech Republic',
      DK: 'Denmark',
      EE: 'Estonia',
      FO: 'Faroe Islands',
      FI: 'Finland',
      FR: 'France',
      DE: 'Germany',
      GI: 'Gibraltar',
      GR: 'Greece',
      VA: 'Holy See (Vatican City State)',
      HU: 'Hungary',
      IS: 'Iceland',
      IE: 'Ireland',
      IM: 'Isle Of Man',
      IT: 'Italy',
      LV: 'Latvia',
      LI: 'Liechtenstein',
      LT: 'Lithuania',
      LU: 'Luxembourg',
      MK: 'Macedonia',
      MT: 'Malta',
      NL: 'Netherlands',
      NO: 'Norway',
      PL: 'Poland',
      PT: 'Portugal',
      RO: 'Romania',
      RU: 'Russian Federation',
      SM: 'San Marino',
      RS: 'Serbia',
      SK: 'Slovakia',
      SI: 'Slovenia',
      ES: 'Spain',
      SE: 'Sweden',
      CH: 'Switzerland',
      UA: 'Ukraine',
    },
  },
  {
    store: siteUrl['int'],
    countries: {
      AF: 'Afghanistan',
      AX: 'Aland Islands',
      DZ: 'Algeria',
      AS: 'American Samoa',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antarctica',
      AG: 'Antigua And Barbuda',
      AR: 'Argentina',
      AM: 'Armenia',
      AW: 'Aruba',
      AZ: 'Azerbaijan',
      BS: 'Bahamas',
      BD: 'Bangladesh',
      BB: 'Barbados',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermuda',
      BT: 'Bhutan',
      BO: 'Bolivia',
      BW: 'Botswana',
      BV: 'Bouvet Island',
      BR: 'Brazil',
      IO: 'British Indian Ocean Territory',
      BN: 'Brunei Darussalam',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Cambodia',
      CM: 'Cameroon',
      CV: 'Cape Verde',
      KY: 'Cayman Islands',
      CF: 'Central African Republic',
      TD: 'Chad',
      CL: 'Chile',
      CN: 'China',
      CX: 'Christmas Island',
      CC: 'Cocos (Keeling) Islands',
      CO: 'Colombia',
      KM: 'Comoros',
      CG: 'Congo',
      CD: 'Congo, Democratic Republic',
      CK: 'Cook Islands',
      CR: 'Costa Rica',
      CI: "Cote D'Ivoire",
      CU: 'Cuba',
      DJ: 'Djibouti',
      DM: 'Dominica',
      DO: 'Dominican Republic',
      EC: 'Ecuador',
      SV: 'El Salvador',
      GQ: 'Equatorial Guinea',
      ER: 'Eritrea',
      ET: 'Ethiopia',
      FK: 'Falkland Islands (Malvinas)',
      FJ: 'Fiji',
      GF: 'French Guiana',
      PF: 'French Polynesia',
      TF: 'French Southern Territories',
      GA: 'Gabon',
      GM: 'Gambia',
      GE: 'Georgia',
      GH: 'Ghana',
      GL: 'Greenland',
      GD: 'Grenada',
      GP: 'Guadeloupe',
      GU: 'Guam',
      GT: 'Guatemala',
      GG: 'Guernsey',
      GN: 'Guinea',
      GW: 'Guinea-Bissau',
      GY: 'Guyana',
      HT: 'Haiti',
      HM: 'Heard Island & Mcdonald Islands',
      HN: 'Honduras',
      HK: 'Hong Kong',
      IN: 'India',
      ID: 'Indonesia',
      IR: 'Iran, Islamic Republic Of',
      JM: 'Jamaica',
      JP: 'Japan',
      JE: 'Jersey',
      KZ: 'Kazakhstan',
      KE: 'Kenya',
      KI: 'Kiribati',
      KR: 'Korea',
      KG: 'Kyrgyzstan',
      LA: "Lao People's Democratic Republic",
      LS: 'Lesotho',
      LR: 'Liberia',
      LY: 'Libyan Arab Jamahiriya',
      MO: 'Macao',
      MG: 'Madagascar',
      MW: 'Malawi',
      MY: 'Malaysia',
      MV: 'Maldives',
      ML: 'Mali',
      MH: 'Marshall Islands',
      MQ: 'Martinique',
      MR: 'Mauritania',
      MU: 'Mauritius',
      YT: 'Mayotte',
      MX: 'Mexico',
      FM: 'Micronesia, Federated States Of',
      MD: 'Moldova',
      MC: 'Monaco',
      MN: 'Mongolia',
      ME: 'Montenegro',
      MS: 'Montserrat',
      MA: 'Morocco',
      MZ: 'Mozambique',
      MM: 'Myanmar',
      NA: 'Namibia',
      NR: 'Nauru',
      NP: 'Nepal',
      AN: 'Netherlands Antilles',
      NC: 'New Caledonia',
      NI: 'Nicaragua',
      NE: 'Niger',
      NG: 'Nigeria',
      NU: 'Niue',
      NF: 'Norfolk Island',
      MP: 'Northern Mariana Islands',
      PK: 'Pakistan',
      PW: 'Palau',
      PS: 'Palestinian Territory, Occupied',
      PA: 'Panama',
      PG: 'Papua New Guinea',
      PY: 'Paraguay',
      PE: 'Peru',
      PH: 'Philippines',
      PN: 'Pitcairn',
      PR: 'Puerto Rico',
      RE: 'Reunion',
      RW: 'Rwanda',
      BL: 'Saint Barthelemy',
      SH: 'Saint Helena',
      KN: 'Saint Kitts And Nevis',
      LC: 'Saint Lucia',
      MF: 'Saint Martin',
      PM: 'Saint Pierre And Miquelon',
      VC: 'Saint Vincent And Grenadines',
      WS: 'Samoa',
      ST: 'Sao Tome And Principe',
      SN: 'Senegal',
      SC: 'Seychelles',
      SL: 'Sierra Leone',
      SG: 'Singapore',
      SB: 'Solomon Islands',
      SO: 'Somalia',
      ZA: 'South Africa',
      GS: 'South Georgia And Sandwich Isl.',
      LK: 'Sri Lanka',
      SD: 'Sudan',
      SR: 'Suriname',
      SJ: 'Svalbard And Jan Mayen',
      SZ: 'Swaziland',
      TW: 'Taiwan',
      TJ: 'Tajikistan',
      TZ: 'Tanzania',
      TH: 'Thailand',
      TL: 'Timor-Leste',
      TG: 'Togo',
      TK: 'Tokelau',
      TO: 'Tonga',
      TT: 'Trinidad And Tobago',
      TN: 'Tunisia',
      TM: 'Turkmenistan',
      TC: 'Turks And Caicos Islands',
      TV: 'Tuvalu',
      UG: 'Uganda',
      UY: 'Uruguay',
      UZ: 'Uzbekistan',
      VU: 'Vanuatu',
      VE: 'Venezuela',
      VN: 'Viet Nam',
      VG: 'Virgin Islands, British',
      VI: 'Virgin Islands, U.S.',
      WF: 'Wallis And Futuna',
      EH: 'Western Sahara',
      YE: 'Yemen',
      ZM: 'Zambia',
      ZW: 'Zimbabwe',
      AE: 'United Arab Emirates',
      OM: 'Oman',
      QA: 'Qatar',
      BH: 'Bahrain',
      LB: 'Lebanon',
      JO: 'Jordan',
      SY: 'Syrian Arab Republic',
      IL: 'Israel',
      IQ: 'Iraq',
      EG: 'Egypt',
      TR: 'Turkey',
    },
  },
  {
    store: siteUrl['middleEastDistributor'],
    countries: {
      KW: 'Kuwait',
      SA: 'Saudi Arabia',
    },
  },
];

const getCountryObject = (countryCode: string): CountryObject => {
  for (const store of stores) {
    if (store.countries[countryCode])
      return {
        site: store.store,
        name: store.countries[countryCode],
        code: countryCode,
      };
  }
  return {
    site: siteUrl['int'],
    name: '',
    code: countryCode,
  };
};

const shouldSiteRedirect = (countryObject: CountryObject): boolean => {
  const sessionRedirectCheck = sessionStorage.getItem('dontRedirect');
  if (sessionRedirectCheck === 'true') return false;

  const cookieRedirectCheck = Cookies.get('dontRedirect');
  if (cookieRedirectCheck === 'true') return false;

  const isGoogleBot = navigator.userAgent.includes('Googlebot');
  if (isGoogleBot) return false;

  const isShopifyPreview = window.location.href.includes('shopifypreview.com');
  if (isShopifyPreview) return false;

  const hasRdrParam = window.location.href.includes('rdr=1');
  if (hasRdrParam) return false;

  const isInCart = window.location.pathname.includes('cart');
  if (isInCart) return false;

  // Compare bare hostnames: 'https://us.hismileteeth.com' → 'us.hismileteeth.com'
  // matched against window.location.hostname ('us.hismileteeth.com'). Equality
  // (not includes) avoids the apex 'hismileteeth.com' matching every subdomain.
  const targetHostname = new URL(countryObject.site).hostname;
  const isInCorrectStore = targetHostname === window.location.hostname;
  if (isInCorrectStore) return false;

  return true;
};

const setStorageAndCookies = (boolean: boolean): void => {
  const booleanString: string = (!boolean).toString();
  sessionStorage.setItem('dontRedirect', booleanString);
  Cookies.set('dontRedirect', booleanString, { expires: 30 });
};

const startSiteRedirect = (countryObject: CountryObject): void => {
  const { site } = countryObject;
  if (site.includes(siteUrl.middleEastDistributor)) {
    window.location.href = site;
    return;
  }

  const { hash, search, pathname } = window.location;
  const urlParams = new URLSearchParams(search);
  urlParams.set('rdr', '1');
  window.location.href = `${site}${pathname}?${urlParams}${hash}`;
};

export const redirectCheck = (countryCode: string, region: string) => {
  const countryObject: CountryObject = getCountryObject(countryCode);
  Cookies.set('slCCodes', JSON.stringify(countryObject), { expires: 30 });

  const siteShouldRedirect = shouldSiteRedirect(countryObject) && region !== 'DEV';
  setStorageAndCookies(siteShouldRedirect);
  if (siteShouldRedirect) startSiteRedirect(countryObject);
  else document.documentElement.style.opacity = '1';
};

// Reads the cached country code from the slCCodes cookie. Supports both
// the current shape ({ code }) and the legacy shape ({ Code }) so returning
// visitors from the previous codebase still hit the cache.
const getCachedIsoCode = (): string | undefined => {
  const raw = Cookies.get('slCCodes');
  if (!raw) return undefined;
  try {
    const parsed = JSON.parse(raw) as { code?: string; Code?: string };
    return parsed.code || parsed.Code;
  } catch {
    return undefined;
  }
};

(async () => {
  //A redirect landing (rdr=1) is guaranteed to stay put — Reveal immediately;
  // Hide the page during the redirect check so visitors don't see the
  // wrong storefront flash before the redirect fires. Revealed by
  // redirectCheck when staying; window.location.href takes over when redirecting.

  const isRedirectLanding = window.location.href.includes('rdr=1');

  if (isRedirectLanding) {
    document.documentElement.style.opacity = '1';
  } else {
    const dontRedirect = sessionStorage.getItem('dontRedirect') === 'true';
    if (!dontRedirect) document.documentElement.style.opacity = '0';
  }

  let isoCode = getCachedIsoCode();
  if (!isoCode) isoCode = await resolveIsoCode();
  if (!isoCode) isoCode = window.shopifyLocalization?.isoCode;

  if (isoCode) {
    redirectCheck(isoCode, window.shopAttributes.regionWithDev);
  } else {
    document.documentElement.style.opacity = '1';
  }
})();
